import React from 'react';

import { calcSimilarityPercent } from '@vlabs/shared/utils';
import { useTranslation } from 'react-i18next';

import { ResultSectionPanel } from '@vlabs/pages/checks/components/result-section-panel/ResultSectionPanel';

import { ResultItem } from '../../../components/result-item/ResultItem';
import { CheckTag } from '../check-tag';
import type { LivenessSectionProps } from './types';

function LivenessSection({
  value,
}: LivenessSectionProps): React.JSX.Element | null {
  const { t } = useTranslation();
  const status = value?.prediction;
  if (!value) return null;

  return (
    <ResultSectionPanel title={t('Liveness')}>
      <ResultItem label={t('checks:page.title.result')}>
        {calcSimilarityPercent(value?.estimations.score)}
        <CheckTag
          kind={status}
          value={t(`checks:result panel.results.liveness_states.${status}`)}
        />
      </ResultItem>
    </ResultSectionPanel>
  );
}

export { LivenessSection };
